import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useStore from "../../Store/Store";
import SimulationTutorial from "../TutorialComponents/SimulationTutorial";
import { theme } from "../../Themes/Themes";

export default function SimulationTutorialDialog() {
  const { dialog, setDialog } = useStore((state) => ({
    dialog: state.dialog,
    setDialog: state.setDialog,
  }));

  const handleClose = () => {
    setDialog("");
  };

  return (
    <Dialog
      open={dialog.type === "SIMULATION_TUTORIAL_DIALOG"}
      onClose={handleClose}
      maxWidth="xl"
      fullWidth
      sx={{
        zIndex: 10000100,
      }}
      PaperProps={{
        style: {
          borderRadius: "30px",
          backgroundColor: theme.custom.lightestGrey,
          margin: "0px",
          minHeight: "50vh",
          display: "flex",
          flexDirection: "column",
          zIndex: 10000100,
        },
      }}
    >
      <DialogContent
        style={{
          padding: "0px 0px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflow: "hidden",
          alignItems: "center",
          zIndex: 10000100,
        }}
      >
        <SimulationTutorial isPopup={true} onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
